import { adapter } from '@seek/tealium-adapter';
import type { TrackingProps } from '@seek/tealium-adapter/lib-types/types';

export const trackLink = (eventName: string, props: TrackingProps) => {
  const tracker = adapter();
  tracker.link(eventName, props);
};
